import { render, staticRenderFns } from "./matchAddMember.vue?vue&type=template&id=566cfaf8&scoped=true&"
import script from "./matchAddMember.vue?vue&type=script&lang=js&"
export * from "./matchAddMember.vue?vue&type=script&lang=js&"
import style0 from "./matchAddMember.vue?vue&type=style&index=0&id=566cfaf8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566cfaf8",
  null
  
)

export default component.exports